export class Plan {
  #userInfo = null

  constructor (data) {
    this.#userInfo = data?.userInfo ?? null
  }

  hasUserInfoData = () => {
    return this.#userInfo !== null
  }

  setUserInfo = (userInfo) => {
    this.#userInfo = userInfo
  }

  setBillingDetails = (billingDetails) => {
    this.#userInfo.address = billingDetails
  }

  setBillingCountryCode = (countryCode) => {
    this.#userInfo.address.countryCode = countryCode
  }

  setBillingCountry = (country) => {
    this.#userInfo.address.country = country
  }

  setBillingState = (state) => {
    this.#userInfo.address.state = state
  }

  setBillingCompanyName = (companyName) => {
    this.#userInfo.address.companyName = companyName
  }

  setBillingStreetAndNumber = (streetAndNumber) => {
    this.#userInfo.address.streetNumber = streetAndNumber
  }

  setBillingFirstname = (firstName) => {
    this.#userInfo.address.firstName = firstName
  }

  setBillingLastname = (lastName) => {
    this.#userInfo.address.lastName = lastName
  }

  setBillingCity = (city) => {
    this.#userInfo.address.city = city
  }

  setBillingPostalCode = (postalCode) => {
    this.#userInfo.address.zip = postalCode
  }

  setBillingEmail = (email) => {
    this.#userInfo.address.email = email
  }

  setBillingVAT = (vat) => {
    this.#userInfo.address.VAT = vat
  }

  getUserInfo = () => {
    return this.#userInfo
  }

  getBillingDetails = () => {
    return this.#userInfo?.address
  }

  getBillingCountryCode = () => {
    return this.#userInfo?.address.countryCode ?? 'ch'
  }

  getBillingCountry = () => {
    return this.#userInfo?.address.country ?? 'Switzerland'
  }

  getBillingState = () => {
    return this.#userInfo?.address.state ?? ''
  }

  getBillingCompanyName = () => {
    return this.#userInfo?.address.companyName ?? ''
  }

  getBillingStreetAndNumber = () => {
    return this.#userInfo?.address.streetNumber ?? ''
  }

  getBillingFirstname = () => {
    return this.#userInfo?.address.firstName ?? ''
  }

  getBillingLastname = () => {
    return this.#userInfo?.address.lastName ?? ''
  }

  getBillingCity = () => {
    return this.#userInfo?.address.city ?? ''
  }

  getBillingPostalCode = () => {
    return this.#userInfo?.address.zip ?? ''
  }

  getBillingEmail = () => {
    return this.#userInfo?.address.email ?? ''
  }

  getBillingVAT = (vat) => {
    return this.#userInfo?.address.vat ?? ''
  }

  getData = () => {
    return {
      userInfo: this.#userInfo
    }
  }
}
